"use strict";
import { useContext } from "react";
import { ShellContext } from "../context";
export function useLogoutNotification() {
  const { isLoggingOut, notifyLogoutStarted } = useContext(ShellContext);
  return { isLoggingOut, notifyLogoutStarted };
}
